// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "campaign_troubleshoot_state".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "campaign_troubleshoot_state" table (1:1 with a DB row, on the wire). */
export const campaignTroubleshootStateAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    metaCampaignId: z.string(),
    currentRound: z.enum(['none', 'offer_adjusted', 'creative_refreshed']),
    offersTried: z.unknown(),
    creativesTried: z.unknown(),
    escalatedAt: z.string().datetime().nullable(),
    lastDiagnosedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=campaignTroubleshootState.js.map